import React from 'react';
import { Draggable } from 'react-beautiful-dnd';
import { TaskContainer } from './style/style';

const Task = (props) => {
  return (
    <Draggable
      key={props.task.id}
      draggableId={props.task.id}
      index={props.index}
      isDragDisabled={props.task.isDragDisabled}
    >
      {(provided, snapshot) => (
        <TaskContainer
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          ref={provided.innerRef}
          isDragging={snapshot.isDragging} // 드래그 중일 때의 스타일링을 위해 snapshot 속성을 외부로 가져옴
          isDragDisabled={props.task.isDragDisabled}
          onDoubleClick={(e) => {
            if (props.onDoubleClick) {
              props.onDoubleClick(props.task);
            }
          }}
        >
          <div className="task">
            <span style={{ width: `${props.task.customData.valueNow}%` }}></span>
            <h5>{props.task.content}</h5>
            <p>{props.task.customData.valueNow}%</p>
          </div>
        </TaskContainer>
      )}
    </Draggable>
  );
};

export default Task;
